/*
 * angular-fullcalendar directive
 * https://github.com/JavyMB/angular-fullcalendar
 *
 * This was originally taken from a fork with fullcalendar v4 support:
 * https://github.com/acutulus/angular-fullcalendar/blob/c4bfb292d923b3f195131e46f39bffbf05993af5/src/angular-fullcalendar.js
 *
 * Modified to work with fullcalendar v5 using es6 import
 */

// import { Calendar } from '@fullcalendar/core';
// import { Calendar } from 'fullcalendar/main';
// import stuff from 'fullcalendar/main';
// import { Calendar } from '@fullcalendar/core';

// import dayGridPlugin from '@fullcalendar/daygrid';
// import interactionPlugin from '@fullcalendar/interaction';
// import calstuff from '../../../../../vendor/fullcalendar-5.3.2-with-drag';
// import { Calendar } from '../../../../../vendor/fullcalendar/packages/core';
// import fullCalendarCommon from '../../../../../vendor/fullcalendar/packages/common';
// import dayGridPlugin from '../../../../../vendor/fullcalendar/packages/daygrid';
// import interactionPlugin from '../../../../../vendor/fullcalendar/packages/interaction';

// WORKING VERSION
import { Calendar } from '@fullcalendar/core';

import dayGridPlugin from '@fullcalendar/daygrid';

// NOT WORKING VERSION
// import { Calendar } from '../../../../../vendor/fullcalendar/packages/core';
// import fullCalendarCommon from '../../../../../vendor/fullcalendar/packages/common';
// import dayGridPlugin from '../../../../../vendor/fullcalendar/packages/daygrid';
// import interactionPlugin from '../../../../../vendor/fullcalendar/packages/interaction';

angular.module('angular-fullcalendar',[])
  .value('CALENDAR_DEFAULTS', {
    locale: 'en',
    timezone : 'local',
    initialView: 'dayGridMonth',
    eventRender: function(e) {}
  })
  .directive('fc', ['CALENDAR_DEFAULTS', fcDirectiveFn]);

function fcDirectiveFn(CALENDAR_DEFAULTS) {
  return {
    restrict : 'A',
    scope : {
      eventSource : '=ngModel',
      options : '=fcOptions',
      onInit: '&onInit',
    },
    link:function (scope, elm) {
      let calendar;
      init();
       //setInterval(init, 10000);
      scope.$watch('eventSource', watchDirective,true);
      scope.$watch('options',watchDirective,true);
      scope.$on('$destroy', function () { destroy();});
      scope.$on('DashboardScreen.calendarCollapseChanged', function() { updateSize(); });
      function init() {
        if (!calendar) {
          let rawElement = elm.get(0);
          calendar = new Calendar(rawElement, getOptions(scope.options));
          calendar.render();
          if (scope.onInit) {
            scope.onInit({ calendar });
          }
        }
      }
      function updateSize() {
        calendar && calendar.updateSize();
      }
      function destroy() {
        if (calendar) {
          calendar.destroy();
          calendar = null;
        }
        // if(calendar && calendar.fullCalendar){
        //   calendar.fullCalendar('destroy');
        // }
      }
      function getPlugins(options) {
        let plugins = options.plugins || [];
        if (!plugins.length) {
          plugins.push(dayGridPlugin);
          // plugins.push(interactionPlugin);
        }
        return plugins;
      }
      function getOptions(options) {
        const event_source=scope.eventSource;
        let isMultiSource=false;
        Object.keys(event_source[0]).forEach(key => {
          if(key==="events"){
            isMultiSource=true;
          }
        });

        if(isMultiSource){
          return angular.extend(CALENDAR_DEFAULTS,{
            eventSources: event_source,
            plugins: getPlugins(options),
          }, options);
        }else{
          return angular.extend(CALENDAR_DEFAULTS,{
            events: event_source,
            plugins: getPlugins(options),
          }, options);
        }

      }
      function watchDirective(newOptions,oldOptions) {
        if (newOptions !== oldOptions) {
          destroy();
          init();
        } else if ((newOptions && angular.isUndefined(calendar))) {
          init();
        }
      }
    }
  };

}
